import { authGet } from "@api/auth/auth";
import { AUTH_URL } from "@constants";
import { AppConfig } from "@types";

export const fetchAppConfig = (): Promise<AppConfig> => {
  return authGet<AppConfig>(`${AUTH_URL}/config`);
};
